module.exports = __webpack_public_path__ + "static/media/ab_3.db2e4707.png";